import { useEffect, useState } from 'react';

import { getStripeFeature, getUserInfo } from '@/pages/AccountSettings/api';

export function useBillingStatus() {
  const [billingEnabled, setBillingEnabled] = useState(false);
  const [stripeAccountExists, setStripeAccountExists] = useState(false);
  const [stripeSetupComplete, setStripeSetupComplete] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      try {
        const [rawFeat, rawUserInfo] = await Promise.all([getStripeFeature(), getUserInfo()]);
        const feat = rawFeat ?? { features: [] };
        const userInfo = rawUserInfo ?? {
          user: {
            stripe_connected_account_id: '',
            stripe_connected_account_details_submitted: false,
          },
        };

        setBillingEnabled(feat.features.includes('BILLING'));

        const acctId = userInfo.user.stripe_connected_account_id;
        const submitted = userInfo.user.stripe_connected_account_details_submitted;
        setStripeAccountExists(acctId !== '');
        setStripeSetupComplete(acctId !== '' && submitted);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  return { billingEnabled, stripeAccountExists, stripeSetupComplete, loading };
}
